var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h4 class=\"no-product-selected\">\n  "
    + container.escapeExpression(__default(require("../../helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Enable search to display the products and download them",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":2,"column":65}}}))
    + "\n</h4>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /src/views/combined/NoProductSelected.hbs
// module id = 2065
// module chunks = 0